import service from "@/api/service";
import {
  SearchRequest,
  SortRequest,
  DeleteRequest,
  DetailRequest,
  RegisterRequest
} from "@/api/menu/request";
import { SearchResponse, DetailResponse } from "@/api/menu/response";
import { CommonResponse } from "@/api/response";

/**
 * メニュー一覧・検索APIをコールします。
 *
 * @param searchRequest メニュー検索のリクエストボディ
 * @return SearchResponse
 */
export async function search(searchRequest: SearchRequest) {
  const response = await service.post("/search-menu", searchRequest);
  return response.data as SearchResponse;
}

/**
 * メニュー詳細情報取得APIをコールします。
 *
 * @param detailRequest メニュー詳細情報取得のリクエストボディ
 * @return DetailResponse
 */
export async function detail(detailRequest: DetailRequest) {
  const response = await service.post("/detail-menu", detailRequest);
  return response.data as DetailResponse;
}

/**
 * メニュー情報登録更新APIをコールします。
 *
 * @param registerRequest メニュー情報登録更新のリクエストボディ
 * @return CommonResponse
 */
export async function register(registerRequest: RegisterRequest) {
  const response = await service.post("/regist-menu", registerRequest);
  return response.data as CommonResponse;
}

/**
 * メニュー並び替え登録更新APIをコールします。
 *
 * @param sortRequest
 * @return CommonResponse
 */
export async function sort(sortRequest: SortRequest) {
  const response = await service.post("/sort-menu", sortRequest);
  return response.data as CommonResponse;
}

/**
 * メニュー情報削除APIをコールします。
 *
 * @param deleteRequest
 * @return CommonResponse
 */
export async function deleteOne(deleteRequest: DeleteRequest) {
  const response = await service.post("/delete-menu", deleteRequest);
  return response.data as CommonResponse;
}
